export default {
  locale: 'ru-RU',
  lang: 'ru',
}
